import { Header } from 'layouts/SignUpTemplate/components/Header';
import * as React from 'react';
import { CompanyTypeSelector, CreateFormValues } from './CompanyTypeSelector';

interface Props {
  submit: (values: CreateFormValues) => void;
}

export const CompanyCreation: React.FC<Props> = (props) => {
  return (
    <div className="w-full max-w-[520px] space-y-8">
      <Header
        header="Create your company"
        subHeader="Select your company type (only one choice):"
      />
      <CompanyTypeSelector submit={props.submit} />
    </div>
  );
};
CompanyCreation.displayName = 'CreateCompany.CompanyCreation';
